//自定义插件模块
import axios from 'axios'
import router from '@/router/index'

const MyHttpServer = {}

MyHttpServer.install = function (Vue) {
  //设置统一请求的服务器地址
//  axios.defaults.baseURL = $url
// axios.defaults.baseURL = $url
  //  axios.defaults.baseURL = $url
   axios.defaults.baseURL = window.gurl.SERVICE_CONTEXT_PATH;

  // 添加请求拦截器
  axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.common['token'] = token
    }
    return config
  }, function (error) {
    console.log(error)
    // 对请求错误做些什么
    return Promise.reject(error);
  });

  // 添加响应拦截器
  axios.interceptors.response.use(function (response) {
    // console.log(response)
    // 对响应数据做点什么
    return response.data;
  }, function (error) {
    if (error.response) {
      if (error.response.data.code == 401) {
        router.replace({
          path: 'login',
          query: { redirect: router.currentRoute.fullPath }
        })
      }
    }
    // 对响应错误做点什么
    return Promise.reject(error);
  });
  //  添加实例方法
  Vue.prototype.$http = axios
  Vue.prototype.$url = window.gurl.SERVICE_CONTEXT_PATH;
}

export default MyHttpServer



// WEBPACK FOOTER //
// ./src/plugins/https.js